<template>
  <div class="wow">
    <div class="scroll">
      <div v-if="this.$route.params.pilot === 'ユーザー'">
        <div v-for="tag of userXTags">
          <template v-if="modelsList.includes(tag)">
            <!--            <h1>Models</h1>-->
          </template>

          <RouterComponent
              v-else
              :title="tag"
              :parsed="userParser(userDoc2, tag)"
              pilot="ユーザー"
          ></RouterComponent>
        </div>
      </div>
      <div v-else-if="this.$route.params.pilot === '管理者'">
        <div v-for="tag of managerTags">
          <RouterComponent
              :title="tag"
              :parsed="managerParser(managerDoc2, tag)"
              pilot="管理者"
          ></RouterComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import RouterComponent from './RouterComponent';

// Functions
import {userParser, managerParser, getXTags, getTags} from '../data/userData';

export default {
  name: 'DetailAside',
  components: {
    RouterComponent,
  },
  props: {
    userDoc2: Object,
    managerDoc2: Object,
  },
  data() {
    return {
      userXTags: getXTags(this.userDoc2),
      managerTags: getTags(this.managerDoc2),
      modelsList: this.userDoc2['x-tagGroups'].filter(
          (item) => item.name === 'Models',
      )[0].tags,
    };
  },
  methods: {
    userParser,
    managerParser,
  },
};
</script>

<style scoped lang="scss">
.wow {
  width: 39em;
  position: sticky;
  align-self: flex-start;
  height: calc(100vh - 30px - 2em);
  top: calc(38px + 1em);
}

.scroll {
  background-color: #f6fafd;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
</style>
